import {
  UPDATE_FEATUREEDIT_DATA,
  SET_FEATUREEDITMODALVISIBLE,
  SET_OPERATETYPE,
  SET_CONFIRMLOADING,
  SET_SOURCETRABSTYPE,
} from '../actions/featureEdit';

const defVal = {
  // 是否显示
  featureEditModalVisible: false,
  // 操作类别 add 添加 edit 编辑
  operateType: 'add',
  // loading状态
  confirmLoading: false,
  // 编辑已添加功能点时使用
  sourceTrabsType: 1,
  id: 1,

  // 数据
  featureEditData: {
    // 功能点类型 1-属性，2-操作，3-事件
    featureType: "1",
    // 功能名称	
    deName: '',
    // 功能名称(中文)	
    deNameCh: '',
    // 功能名称(英文)	
    deNameEn: '',
    //isTemplate为1代表标准功能,0为自定义功能
    isTemplate: 0,
    // 识别符
    deKey: '',
    // 是否可选	0 必选 1 可选
    deOptional: 1,
    // 功能备注	
    deRemark: '',
    // 传输类型	 1-只上报；2-只下发；3-上报下发；4-操作
    transType: 1,
    // 数据类型	string，json，boolean，enum，integer
    dataType: 'boolean',
    // 最大长度
    maxLength: '',
    // 枚举类型
    enumType: 'integer',
    // 枚举值	
    enumValue: [],
    // 最小值	
    minimum: '',
    // 最大值	
    maximum: '',
    // 倍数	
    multipleOf: '',
    // 间隔
    step: '',
    // json 数据类型值
    properties: [{
      "deKey": "",
      "type": "boolean",
      "title": "",
      "description": null,
      "enumValue": [],
      "defaultValue": null,
      "constValue": null,
      "unit": null,
      "storage": null,
      "minLength": null,
      "maxLength": '',
      "pattern": null,
      "format": null,
      "minimum": null,
      "exclusiveMinimum": null,
      "maximum": null,
      "exclusiveMaximum": null,
      "multipleOf": null,
      "step": null,
      "required": null,
      "properties": null,
      "maxProperties": null,
      "minProperties": null,
      "dependencies": null,
      "enumType": "string"
    }],
    // 数据类型	String，json，boolean，enum，integer
    dataType2: 'boolean',
    enumType2: 'integer',
    // 最大长度
    maxLength2: '',
    // 枚举值	
    enumValue2: [],
    // 最小值	
    minimum2: '',
    // 最大值	
    maximum2: '',
    // 倍数	
    multipleOf2: '',
    // 间隔
    step2: '',
    // json 数据类型值
    properties2: [{
      "deKey": "",
      "type": "boolean",
      "title": "",
      "description": null,
      "enumValue": [],
      "defaultValue": null,
      "constValue": null,
      "unit": null,
      "storage": null,
      "minLength": null,
      "maxLength": '',
      "pattern": null,
      "format": null,
      "minimum": null,
      "exclusiveMinimum": null,
      "maximum": null,
      "exclusiveMaximum": null,
      "multipleOf": null,
      "step": null,
      "required": null,
      "properties": null,
      "maxProperties": null,
      "minProperties": null,
      "dependencies": null,
      "enumType": "string"
    }],
  }

};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_FEATUREEDIT_DATA:
      return Object.assign({}, state, {
        featureEditData: action.featureEditData,
      });
    case SET_FEATUREEDITMODALVISIBLE:
      return Object.assign({}, state, {
        featureEditModalVisible: action.featureEditModalVisible,
      });
    case SET_OPERATETYPE:
      return Object.assign({}, state, {
        operateType: action.operateType,
      });
    case SET_CONFIRMLOADING:
      return Object.assign({}, state, {
        confirmLoading: action.confirmLoading,
      });
    case SET_SOURCETRABSTYPE:
      return Object.assign({}, state, {
        sourceTrabsType: action.sourceTrabsType,
        id: action.id,
      });
    default:
      return state;
  }
};
